var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 -2.5H26.5V26.5H-2.5V-2.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.604 3.08L14.8115 2.665C14.9977 2.2925 14.9977 1.85375 14.8115 1.48125C14.5865 1.03375 14.129 0.75 13.6265 0.75H10.9615C10.4602 0.75 10.0015 1.03375 9.77774 1.48125C9.59149 1.85375 9.59149 2.2925 9.77774 2.665L9.98524 3.08C10.089 3.28875 10.144 3.5175 10.144 3.75125V4.9825C10.144 6.4325 9.66774 7.84375 8.78774 8.99625L8.35774 9.56C7.47649 10.7138 7.00024 12.1238 7.00024 13.575V20.6037C7.00024 22.065 8.18524 23.25 9.64774 23.25H14.9415C16.404 23.25 17.589 22.065 17.589 20.6025V13.575C17.589 12.125 17.1127 10.7137 16.2327 9.56125L15.8015 8.99625C14.9215 7.8425 14.4452 6.4325 14.4452 4.9825V3.75125C14.4452 3.51875 14.499 3.28875 14.604 3.08V3.08Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.137 3.86353H14.4495",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 18.2502H7.01123",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 13.2498H7.01123",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleIcon);
export default __webpack_public_path__ + "static/media/bottle-icon.d240fa0e39f5ea5ce59f58cbb51d1073.svg";
export { ForwardRef as ReactComponent };